exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"tab_unfinished_tasks.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-123d1a2b","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/tabs/tabs_detailed_progress/tab_unfinished_tasks.vue
// module id = V/6Z
// module chunks = 2